export const company_name = 'QblackAI';
